import { render } from "./MainMenuSmall.vue?vue&type=template&id=4083f238&scoped=true"
import script from "./MainMenuSmall.vue?vue&type=script&lang=js"
export * from "./MainMenuSmall.vue?vue&type=script&lang=js"

import "./MainMenuSmall.vue?vue&type=style&index=0&id=4083f238&scoped=true&lang=css"

import exportComponent from "d:\\presta\\dev\\key4access\\key4access.front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4083f238"]])

export default __exports__